import React from 'react';
import { useSelector } from 'react-redux';

import { Button, WrapperFlex } from '@unimed-fesp/components';

import { MdCancel } from 'react-icons/md';
import { IoIosCheckmarkCircle } from 'react-icons/io';

import { ReactComponent as ReplyAll } from '../../../assets/icons/reply_all-24px.svg';

import theme from '../../../styles/theme';

import { isContratante } from '../../../utils/userRole';

const ModalFooter = ({
  idStatusLista,
  onAceitar,
  onRecusar,
  onCancelar,
  reenviarDocumento,
  esconderBtnReenviar,
}) => {
  const { usuario } = useSelector((state) => state.auth);

  return (
    <WrapperFlex justifySpaceBetween fullWidth>
      <Button
        tipo="tertiary"
        justifySpaceAround
        alignCenter
        onClick={onCancelar}
        font="16px unimed_slabregular"
        background="rgba(242,242,242,1)"
      >
        cancelar
      </Button>
      <WrapperFlex justifyEnd>
        {isContratante(usuario.role) && !esconderBtnReenviar && (
          <Button
            tipo="primary"
            paddingTop={1}
            paddingRight={1}
            paddingBottom={1}
            paddingLeft={1}
            justifySpaceAround
            alignCenter
            width={200}
            onClick={() => reenviarDocumento()}
            font="16px unimed_slabregular"
          >
            <ReplyAll fill={theme.white} size="20" />
            reenviar documento
          </Button>
        )}
        {!isContratante(usuario.role) && idStatusLista === 16 && (
          <>
            <Button
              paddingTop={1}
              paddingRight={1}
              paddingBottom={1}
              paddingLeft={1}
              padding={1}
              tipo="secondary"
              justifySpaceAround
              alignCenter
              marginRight={10}
              onClick={onRecusar}
              width={100}
            >
              <MdCancel color={theme.greenDefault} size="20" />
              recusar
            </Button>
            <Button
              tipo="primary"
              paddingTop={1}
              paddingRight={1}
              paddingBottom={1}
              paddingLeft={1}
              justifySpaceAround
              alignCenter
              onClick={onAceitar}
              width={100}
            >
              <IoIosCheckmarkCircle size="20" />
              aceitar
            </Button>
          </>
        )}
      </WrapperFlex>
    </WrapperFlex>
  );
};

export default ModalFooter;
